module.exports = __webpack_public_path__ + "img/vue1-milieu_gris.dfaa4668.png";